import { useEffect } from "react";
import { useHistory } from "react-router";
// Components
import BannerOne from "../../../components/BannerOne";

// Constants
import { TITLE, SUB_TITLE, BUTTON_NAME , BUTTON_LINK, SECOND_BUTTON_NAME, SECOND_BUTTON_LINK, ALL_CARD_ROWS} from "./HomepageConstants";
import { SIGN_UP_TITLE, SIGN_UP_SUB_TITLE, BANNER_LINK, BUTTON_NAME_SIGN_UP } from "./HomepageConstants";

// Images
import homepageBanner from '../../../assets/img/partnerPortal/homepage.png';

// Scss
import '../../../assets/css/partnerProgram.scss';
import CardsFormatThree from "../../../components/CardsFormatThree";
import SignUpBlockHomepage from "../../../components/SignUpBlockHomepage";

function Homepage() {

  let history = useHistory();

//   useEffect(() => {
//     canYouHaveAccess();


//   }, []);

  return (
    <>
      <div>

        <BannerOne bannerImage={homepageBanner} title={TITLE} subTitle={SUB_TITLE} buttonName={BUTTON_NAME} buttonLink={BUTTON_LINK} secondButtonName={SECOND_BUTTON_NAME} secondButtonLink={SECOND_BUTTON_LINK} secondButtonTarget="_parent"/>
        <CardsFormatThree cards={ALL_CARD_ROWS} />
        <SignUpBlockHomepage title={SIGN_UP_TITLE} subTitle={SIGN_UP_SUB_TITLE} buttonName={BUTTON_NAME_SIGN_UP} bannerLink={BANNER_LINK} />
      </div >
    </>
  );

//   function canYouHaveAccess() {
//     try {
//       if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
//         console.log("You shall not pass");
//         history.push('/not-found');
//       }
//     } catch (err) {
//       

//     }
//   }

}

export default Homepage;

